import { DocumentReference, Region } from '@principle-theorem/shared';
import { IPractice } from '../practice/practice';

export enum BillingMeterId {
  AiReceptionistMinutes = 'ai_receptionist_minutes',
  AiImagesAnalysed = 'ai_images_analysed',
  SMSOutboundSegments = 'sms_outbound_segments',
  SMSInboundSegments = 'sms_inbound_segments',
  SMSMarketingSegments = 'sms_marketing_segments',
}

export enum BillingMeterPriceLookupId {
  AUSMSInboundStandard = 'au_sms_inbound_standard',
  AUSMSInboundVIP = 'au_sms_inbound_vip',
  NZSMSInboundStandard = 'nz_sms_inbound_standard',
  AUSMSOutboundStandard = 'au_sms_outbound_standard',
  AUSMSOutboundVIP = 'au_sms_outbound_vip',
  NZSMSOutboundStandard = 'nz_sms_outbound_standard',
  AUSMSMarketingStandard = 'au_sms_marketing_standard',
  AUSMSMarketingVIP = 'au_sms_marketing_vip',
  NZSMSMarketingStandard = 'nz_sms_marketing_standard',
}

export const BILLING_METER_DISPLAY_NAME: { [key in BillingMeterId]: string } = {
  [BillingMeterId.AiReceptionistMinutes]: 'AI Receptionist Minutes',
  [BillingMeterId.AiImagesAnalysed]: 'AI Images Analysed',
  [BillingMeterId.SMSOutboundSegments]: 'SMS Outbound Segments',
  [BillingMeterId.SMSInboundSegments]: 'SMS Inbound Segments',
  [BillingMeterId.SMSMarketingSegments]: 'SMS Marketing Segments',
};

export interface IBillingMeter {
  practiceRef: DocumentReference<IPractice>;
  billingMeterId: BillingMeterId;
  stripeMeterId: string;
  stripePriceId?: string;
}

export type BillingMeterIdMap = {
  [key in BillingMeterId]: string;
};

export interface IBillingMeterOption {
  meterId: BillingMeterId;
  region: Region;
  priceLookupId: BillingMeterPriceLookupId;
  pricingDescription: string;
  costInCents: number;
  isDefault?: boolean;
}

export const BILLING_METERS: Record<
  BillingMeterPriceLookupId,
  IBillingMeterOption
> = {
  [BillingMeterPriceLookupId.AUSMSInboundStandard]: {
    meterId: BillingMeterId.SMSInboundSegments,
    region: Region.Australia,
    priceLookupId: BillingMeterPriceLookupId.AUSMSInboundStandard,
    pricingDescription: '$0.025 AUD per SMS segment',
    costInCents: 2.5,
    isDefault: true,
  },
  [BillingMeterPriceLookupId.AUSMSInboundVIP]: {
    meterId: BillingMeterId.SMSInboundSegments,
    region: Region.Australia,
    priceLookupId: BillingMeterPriceLookupId.AUSMSInboundVIP,
    pricingDescription: '$0.015 AUD per SMS segment',
    costInCents: 1.5,
    isDefault: true,
  },
  [BillingMeterPriceLookupId.NZSMSInboundStandard]: {
    meterId: BillingMeterId.SMSInboundSegments,
    region: Region.NewZealand,
    priceLookupId: BillingMeterPriceLookupId.NZSMSInboundStandard,
    pricingDescription: '$0.00 NZD per SMS segment',
    costInCents: 0,
    isDefault: true,
  },
  [BillingMeterPriceLookupId.AUSMSOutboundStandard]: {
    meterId: BillingMeterId.SMSOutboundSegments,
    region: Region.Australia,
    priceLookupId: BillingMeterPriceLookupId.AUSMSOutboundStandard,
    pricingDescription: '$0.12 AUD per SMS segment',
    costInCents: 12,
    isDefault: true,
  },
  [BillingMeterPriceLookupId.AUSMSOutboundVIP]: {
    meterId: BillingMeterId.SMSOutboundSegments,
    region: Region.Australia,
    priceLookupId: BillingMeterPriceLookupId.AUSMSOutboundVIP,
    pricingDescription: '$0.07 AUD per SMS segment',
    costInCents: 7,
  },
  [BillingMeterPriceLookupId.NZSMSOutboundStandard]: {
    meterId: BillingMeterId.SMSOutboundSegments,
    region: Region.NewZealand,
    priceLookupId: BillingMeterPriceLookupId.NZSMSOutboundStandard,
    pricingDescription: '$0.15 NZD per SMS segment',
    costInCents: 15,
    isDefault: true,
  },
  [BillingMeterPriceLookupId.AUSMSMarketingStandard]: {
    meterId: BillingMeterId.SMSMarketingSegments,
    region: Region.Australia,
    priceLookupId: BillingMeterPriceLookupId.AUSMSMarketingStandard,
    pricingDescription: '$0.12 AUD per SMS segment',
    costInCents: 12,
    isDefault: true,
  },
  [BillingMeterPriceLookupId.AUSMSMarketingVIP]: {
    meterId: BillingMeterId.SMSMarketingSegments,
    region: Region.Australia,
    priceLookupId: BillingMeterPriceLookupId.AUSMSMarketingVIP,
    pricingDescription: '$0.07 AUD per SMS segment',
    costInCents: 7,
  },
  [BillingMeterPriceLookupId.NZSMSMarketingStandard]: {
    meterId: BillingMeterId.SMSMarketingSegments,
    region: Region.NewZealand,
    priceLookupId: BillingMeterPriceLookupId.NZSMSMarketingStandard,
    pricingDescription: '$0.15 NZD per SMS segment',
    costInCents: 15,
    isDefault: true,
  },
};
